export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Scalar for BigDecimal */
  BigDecimal: { input: any; output: any; }
  /** Scalar for BigInteger */
  BigInteger: { input: any; output: any; }
  /** Scalar for Date */
  Date: { input: any; output: any; }
  /** Scalar for DateTime */
  DateTime: { input: any; output: any; }
  /** An object scalar */
  Object: { input: any; output: any; }
  /** Scalar for Time */
  Time: { input: any; output: any; }
};

export type AadeSource_Int = {
  aadeResponse?: Maybe<Scalars['Object']['output']>;
  aadeStatus?: Maybe<AadeSyncStatus>;
  id?: Maybe<Scalars['Int']['output']>;
};

export enum AadeSyncStatus {
  Error = 'ERROR',
  Skipped = 'SKIPPED',
  Success = 'SUCCESS',
  Sync = 'SYNC'
}

export type AbstractAuditableEntity_CountPk = EntityInterface_CountPk & IdContainer_CountPk & {
  __typename?: 'AbstractAuditableEntity_CountPK';
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<CountPk>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AbstractAuditableEntity_Int = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'AbstractAuditableEntity_Int';
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AbstractAuditableEntity_SettingsPk = EntityInterface_SettingsPk & IdContainer_SettingsPk & {
  __typename?: 'AbstractAuditableEntity_SettingsPK';
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<SettingsPk>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AbstractAuditableEntity_String = EntityInterface_String & IdContainer_String & {
  __typename?: 'AbstractAuditableEntity_String';
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BaseParamsInput = {
  filters?: InputMaybe<Array<InputMaybe<FilterMetadataInput>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  globalFilter?: InputMaybe<Scalars['String']['input']>;
  rows?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Array<InputMaybe<SortMetadataInput>>>;
};

export enum BillingPolicy {
  Free = 'FREE',
  Invoice = 'INVOICE',
  ReceiptOnly = 'RECEIPT_ONLY'
}

export type Clinic = {
  __typename?: 'Clinic';
  businessAddress: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  code?: Maybe<Scalars['String']['output']>;
  defaultClinic?: Maybe<Clinic>;
  defaultExamLogo?: Maybe<Image>;
  defaultExaminer?: Maybe<Examiner>;
  defaultInvoiceLogo?: Maybe<Image>;
  defaultReceiptLogo?: Maybe<Image>;
  defaultReferralVisibility?: Maybe<Scalars['Boolean']['output']>;
  deleted: Scalars['Boolean']['output'];
  examinerSettings?: Maybe<Array<Maybe<ExaminerSettings>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['Int']['output']>;
  representative: Scalars['String']['output'];
  signature: Image;
  taxOffice: Scalars['String']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vatNumber: Scalars['String']['output'];
};

export type CountPk = {
  __typename?: 'CountPK';
  doctorId: Scalars['Int']['output'];
  imageId: Scalars['Int']['output'];
};

export type Counter = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'Counter';
  id?: Maybe<Scalars['Int']['output']>;
};

export type Doctor = {
  __typename?: 'Doctor';
  avatar?: Maybe<Image>;
  clinic: Clinic;
  company: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  end1?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  end2?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  end3?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  end4?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  end5?: Maybe<Scalars['Time']['output']>;
  examsDeliveryMethod?: Maybe<ExamDeliveryMethod>;
  examsDeliveryMethodComment?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullAddress: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  invoiceAddress?: Maybe<Scalars['String']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  kcId?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  lastActivityDate?: Maybe<Scalars['Date']['output']>;
  /** ISO-8601 */
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  lastNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notificationsEnabled: Scalars['Boolean']['output'];
  orders?: Maybe<Array<Maybe<Order>>>;
  otherDebts?: Maybe<Scalars['Float']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  paymentMethodComment?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recommendationsEnabled: Scalars['Boolean']['output'];
  referrals?: Maybe<Array<Maybe<Referral>>>;
  representative?: Maybe<Scalars['String']['output']>;
  resultsDeliveryMethod?: Maybe<ResultDeliveryMethod>;
  resultsDeliveryMethodComment?: Maybe<Scalars['String']['output']>;
  secretaryName?: Maybe<Scalars['String']['output']>;
  secretaryPhone?: Maybe<Scalars['String']['output']>;
  specialty: Scalars['String']['output'];
  /** ISO-8601 */
  start1?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  start2?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  start3?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  start4?: Maybe<Scalars['Time']['output']>;
  /** ISO-8601 */
  start5?: Maybe<Scalars['Time']['output']>;
  statisticsEnabled: Scalars['Boolean']['output'];
  tags?: Maybe<Array<Maybe<Tag>>>;
  taxOffice?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  vip: Scalars['Boolean']['output'];
};

export type DoctorDashboard = {
  __typename?: 'DoctorDashboard';
  doctor?: Maybe<Doctor>;
  examsPerMonth?: Maybe<Scalars['String']['output']>;
  monthlyExams?: Maybe<Scalars['Int']['output']>;
  monthlyPatients?: Maybe<Scalars['Int']['output']>;
  threeMonthsExams?: Maybe<Scalars['Int']['output']>;
  threeMonthsPatients?: Maybe<Scalars['Int']['output']>;
  totalExams?: Maybe<Scalars['Int']['output']>;
  totalInvoices?: Maybe<Scalars['Int']['output']>;
  totalInvoicesAmount?: Maybe<Scalars['Float']['output']>;
  totalPatients?: Maybe<Scalars['Int']['output']>;
};

export type DoctorDtoInput = {
  avatar?: InputMaybe<ImageDtoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  end1?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  end2?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  end3?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  end4?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  end5?: InputMaybe<Scalars['Time']['input']>;
  examsDeliveryMethod?: InputMaybe<ExamDeliveryMethod>;
  examsDeliveryMethodComment?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  invoiceAddress?: InputMaybe<Scalars['String']['input']>;
  invoiceName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  notificationsEnabled: Scalars['Boolean']['input'];
  paymentMethod?: InputMaybe<PaymentMethod>;
  paymentMethodComment?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recommendationsEnabled: Scalars['Boolean']['input'];
  resultsDeliveryMethod?: InputMaybe<ResultDeliveryMethod>;
  resultsDeliveryMethodComment?: InputMaybe<Scalars['String']['input']>;
  secretaryName?: InputMaybe<Scalars['String']['input']>;
  secretaryPhone?: InputMaybe<Scalars['String']['input']>;
  specialty?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  start1?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  start2?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  start3?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  start4?: InputMaybe<Scalars['Time']['input']>;
  /** ISO-8601 */
  start5?: InputMaybe<Scalars['Time']['input']>;
  statisticsEnabled: Scalars['Boolean']['input'];
  taxOffice?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

export type DoctorExamImageCount = EntityInterface_CountPk & IdContainer_CountPk & {
  __typename?: 'DoctorExamImageCount';
  count: Scalars['Int']['output'];
  doctor?: Maybe<Doctor>;
  id?: Maybe<CountPk>;
  image?: Maybe<Image>;
};

export type DoctorGroupSettings = {
  __typename?: 'DoctorGroupSettings';
  deleted: Scalars['Boolean']['output'];
  doctor: Doctor;
  eopyyPrice?: Maybe<Scalars['Float']['output']>;
  generalPrice?: Maybe<Scalars['Float']['output']>;
  group: ExamGroup;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceDescription?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DoctorInventory = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'DoctorInventory';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  doctor: Doctor;
  id?: Maybe<Scalars['Int']['output']>;
  inventory: Inventory;
  quantity: Scalars['Int']['output'];
};

export type DoctorInventoryTotal = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'DoctorInventoryTotal';
  doctor: Doctor;
  id?: Maybe<Scalars['Int']['output']>;
  inventory: Inventory;
  quantity: Scalars['Int']['output'];
};

export type EditedInsurance = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'EditedInsurance';
  clinic?: Maybe<Clinic>;
  doctor?: Maybe<Doctor>;
  doctorName?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  eventCreatedAt?: Maybe<Scalars['Date']['output']>;
  group?: Maybe<ExamGroup>;
  id?: Maybe<Scalars['Int']['output']>;
  insuranceName?: Maybe<Scalars['String']['output']>;
  oldInsuranceName?: Maybe<Scalars['String']['output']>;
  patientName?: Maybe<Scalars['String']['output']>;
  patientSsn?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  referralDate?: Maybe<Scalars['Date']['output']>;
  whoChanged?: Maybe<Scalars['String']['output']>;
};

export type EntityInterface_CountPk = {
  id?: Maybe<CountPk>;
};

export type EntityInterface_Int = {
  id?: Maybe<Scalars['Int']['output']>;
};

export type EntityInterface_SettingsPk = {
  id?: Maybe<SettingsPk>;
};

export type EntityInterface_String = {
  id?: Maybe<Scalars['String']['output']>;
};

export type Event = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'Event';
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  newValues?: Maybe<Scalars['Object']['output']>;
  oldValues?: Maybe<Scalars['Object']['output']>;
  recordId?: Maybe<Scalars['String']['output']>;
  schemaName?: Maybe<Scalars['String']['output']>;
  tableName?: Maybe<Scalars['String']['output']>;
  txId?: Maybe<Scalars['BigInteger']['output']>;
};

export type Exam = {
  __typename?: 'Exam';
  adminEmails?: Maybe<Scalars['Int']['output']>;
  adminPrints?: Maybe<Scalars['Int']['output']>;
  adminViews?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['Date']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  deleted: Scalars['Boolean']['output'];
  doctorDeleted: Scalars['Boolean']['output'];
  doctorEmails?: Maybe<Scalars['Int']['output']>;
  doctorPrints?: Maybe<Scalars['Int']['output']>;
  doctorViews?: Maybe<Scalars['Int']['output']>;
  examiners?: Maybe<Array<Maybe<Examiner>>>;
  hasPdfGenerated: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  pFlag?: Maybe<PFlagType>;
  referral: Referral;
  relatives?: Maybe<Array<Maybe<Exam>>>;
  template: ExamTemplate;
  tsv?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ExamBundle = {
  __typename?: 'ExamBundle';
  deleted: Scalars['Boolean']['output'];
  examBundleCategory: ExamBundleCategory;
  examBundleRows?: Maybe<Array<Maybe<ExamBundleRow>>>;
  examBundleType: ExamBundleType;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<ExamBundle>;
  price: Scalars['Float']['output'];
  priority?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum ExamBundleCategory {
  Partners = 'PARTNERS',
  Regular = 'REGULAR',
  Repeating = 'REPEATING'
}

export type ExamBundleRow = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'ExamBundleRow';
  eopyy: Scalars['Boolean']['output'];
  examBundle?: Maybe<ExamBundle>;
  examGroup?: Maybe<ExamGroup>;
  id?: Maybe<Scalars['Int']['output']>;
};

export enum ExamBundleType {
  FiveExams = 'FIVE_EXAMS',
  FourExams = 'FOUR_EXAMS',
  Other = 'OTHER',
  ThreeExams = 'THREE_EXAMS',
  TwoExams = 'TWO_EXAMS'
}

export enum ExamDeliveryMethod {
  Courier = 'COURIER',
  Other = 'OTHER',
  Private = 'PRIVATE'
}

export type ExamGroup = {
  __typename?: 'ExamGroup';
  active: Scalars['Boolean']['output'];
  allowCotesting: Scalars['Boolean']['output'];
  clinicsSettings?: Maybe<Array<Maybe<ExamGroupClinicSettings>>>;
  code?: Maybe<Scalars['String']['output']>;
  counter?: Maybe<Counter>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  doctorsSettings?: Maybe<Array<Maybe<DoctorGroupSettings>>>;
  eopyyAllowed: Scalars['Boolean']['output'];
  eopyyPrice?: Maybe<Scalars['Float']['output']>;
  examsTemplates?: Maybe<Array<Maybe<ExamTemplate>>>;
  generalPrice?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoiceDescription?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<ExamGroup>;
  settings?: Maybe<Scalars['Object']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ExamGroupClinicSettings = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'ExamGroupClinicSettings';
  clinic?: Maybe<Clinic>;
  examGroup?: Maybe<ExamGroup>;
  examinerIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  isoLogo?: Maybe<Image>;
};

export type ExamTemplate = {
  __typename?: 'ExamTemplate';
  active: Scalars['Boolean']['output'];
  approval: Scalars['Boolean']['output'];
  clinic?: Maybe<Clinic>;
  data?: Maybe<Scalars['Object']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  group: ExamGroup;
  id?: Maybe<Scalars['Int']['output']>;
  imagesGroup?: Maybe<ImageGroup>;
  important: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pattern: Pattern;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ExamTemplateCount = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'ExamTemplateCount';
  count: Scalars['Int']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ExamWithoutInvoices = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'ExamWithoutInvoices';
  clinic?: Maybe<Clinic>;
  doctorName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  lastInvoiceDate?: Maybe<Scalars['Date']['output']>;
};

export type Examiner = {
  __typename?: 'Examiner';
  active: Scalars['Boolean']['output'];
  deleted: Scalars['Boolean']['output'];
  exams?: Maybe<Array<Maybe<Exam>>>;
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  settings: Array<Maybe<ExaminerSettings>>;
  signature: Image;
  specialty: Scalars['String']['output'];
  ssn?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ExaminerSettings = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'ExaminerSettings';
  clinic?: Maybe<Clinic>;
  examiner?: Maybe<Examiner>;
  id?: Maybe<Scalars['Int']['output']>;
  quota?: Maybe<Scalars['Int']['output']>;
};

export type FileDto = {
  __typename?: 'FileDto';
  content?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  contentType?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
};

export type FilterMetadataInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  matchMode?: InputMaybe<MatchMode>;
  value?: InputMaybe<Scalars['Object']['input']>;
};

export type IdContainer_CountPk = {
  id?: Maybe<CountPk>;
};

export type IdContainer_Int = {
  id?: Maybe<Scalars['Int']['output']>;
};

export type IdContainer_SettingsPk = {
  id?: Maybe<SettingsPk>;
};

export type IdContainer_String = {
  id?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  doctorCount?: Maybe<Array<Maybe<DoctorExamImageCount>>>;
  fileName: Scalars['String']['output'];
  group: ImageGroup;
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ImageDto = {
  __typename?: 'ImageDto';
  fileName?: Maybe<Scalars['String']['output']>;
  full?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  imagesGroupId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
};

export type ImageDtoInput = {
  fileName?: InputMaybe<Scalars['String']['input']>;
  full?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  imagesGroupId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
};

export type ImageGroup = {
  __typename?: 'ImageGroup';
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  images?: Maybe<Array<Maybe<Image>>>;
  name: Scalars['String']['output'];
  parent?: Maybe<ImageGroup>;
  subtype: ImageGroupSubtype;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum ImageGroupSubtype {
  ClinicSignature = 'CLINIC_SIGNATURE',
  DoctorAvatar = 'DOCTOR_AVATAR',
  ExaminerSignature = 'EXAMINER_SIGNATURE',
  Exams = 'EXAMS',
  Logos = 'LOGOS',
  Unique = 'UNIQUE',
  UserAvatar = 'USER_AVATAR'
}

export type Insurance = {
  __typename?: 'Insurance';
  active: Scalars['Boolean']['output'];
  billingPolicy?: Maybe<BillingPolicy>;
  deleted: Scalars['Boolean']['output'];
  eopyy: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  settings?: Maybe<Scalars['Object']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvalidRecipient = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'InvalidRecipient';
  email: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  recipientId?: Maybe<Scalars['Int']['output']>;
  recipientType?: Maybe<RecipientType>;
};

export type Inventory = {
  __typename?: 'Inventory';
  clinic: Clinic;
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** ISO-8601 */
  registrationDate: Scalars['Date']['output'];
  totalQuantity: Scalars['Int']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type Invoice = AadeSource_Int & EntityInterface_Int & IdContainer_Int & {
  __typename?: 'Invoice';
  aadeResponse?: Maybe<Scalars['Object']['output']>;
  aadeStatus?: Maybe<AadeSyncStatus>;
  /** ISO-8601 */
  annulledAt?: Maybe<Scalars['DateTime']['output']>;
  annulledBy?: Maybe<Scalars['String']['output']>;
  clinic: Clinic;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  deleted: Scalars['Boolean']['output'];
  doctor: Doctor;
  id?: Maybe<Scalars['Int']['output']>;
  num?: Maybe<Scalars['String']['output']>;
  rows?: Maybe<Array<Maybe<InvoiceRow>>>;
  sent: Scalars['Int']['output'];
  status?: Maybe<InvoiceStatus>;
  template: InvoiceTemplate;
  total: Scalars['Float']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceBundle = {
  __typename?: 'InvoiceBundle';
  bundlePrice?: Maybe<Scalars['Float']['output']>;
  clinicIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  deleted: Scalars['Boolean']['output'];
  doctor?: Maybe<Doctor>;
  examBundle?: Maybe<ExamBundle>;
  id?: Maybe<Scalars['BigInteger']['output']>;
  invoiceBundleStatus?: Maybe<InvoiceBundleStatus>;
  patient?: Maybe<Patient>;
  /** ISO-8601 */
  periodFrom?: Maybe<Scalars['Date']['output']>;
  /** ISO-8601 */
  periodTo?: Maybe<Scalars['Date']['output']>;
  referrals?: Maybe<Array<Maybe<Referral>>>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceBundleStatus {
  Frozen = 'FROZEN',
  New = 'NEW'
}

export type InvoiceRow = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'InvoiceRow';
  annulled: Scalars['Boolean']['output'];
  article?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  invoice: Invoice;
  price: Scalars['Float']['output'];
  referral?: Maybe<Referral>;
};

export enum InvoiceStatus {
  Annulled = 'ANNULLED',
  Closed = 'CLOSED',
  Opened = 'OPENED'
}

export type InvoiceTemplate = {
  __typename?: 'InvoiceTemplate';
  counter?: Maybe<Counter>;
  data?: Maybe<Scalars['Object']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  pattern: Pattern;
  type: InvoiceTemplateType;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum InvoiceTemplateType {
  Exams = 'EXAMS',
  General = 'GENERAL'
}

export enum MatchMode {
  And = 'AND',
  Between = 'BETWEEN',
  Contains = 'CONTAINS',
  ContainsCi = 'CONTAINS_CI',
  Custom = 'CUSTOM',
  Empty = 'EMPTY',
  EndsWith = 'ENDS_WITH',
  EndsWithCi = 'ENDS_WITH_CI',
  Equals = 'EQUALS',
  EqualsCi = 'EQUALS_CI',
  EqualsOrNull = 'EQUALS_OR_NULL',
  GreaterThan = 'GREATER_THAN',
  GreaterThanOrEqualsTo = 'GREATER_THAN_OR_EQUALS_TO',
  In = 'IN',
  InOrEmpty = 'IN_OR_EMPTY',
  IsNotNull = 'IS_NOT_NULL',
  IsNull = 'IS_NULL',
  JsonEquals = 'JSON_EQUALS',
  JsonExists = 'JSON_EXISTS',
  LessThan = 'LESS_THAN',
  LessThanOrEqualsTo = 'LESS_THAN_OR_EQUALS_TO',
  Like = 'LIKE',
  LikeCi = 'LIKE_CI',
  NotContains = 'NOT_CONTAINS',
  NotEmpty = 'NOT_EMPTY',
  NotEquals = 'NOT_EQUALS',
  NotIn = 'NOT_IN',
  NotInOrNull = 'NOT_IN_OR_NULL',
  Or = 'OR',
  StartsWith = 'STARTS_WITH',
  StartsWithCi = 'STARTS_WITH_CI'
}

export type Message = {
  __typename?: 'Message';
  /** ISO-8601 */
  activeFrom?: Maybe<Scalars['Date']['output']>;
  /** ISO-8601 */
  activeTo?: Maybe<Scalars['Date']['output']>;
  content: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  doctor?: Maybe<Doctor>;
  id?: Maybe<Scalars['Int']['output']>;
  important: Scalars['Boolean']['output'];
  openedCount?: Maybe<Scalars['Int']['output']>;
  reads?: Maybe<Array<Maybe<MessageEvent>>>;
  readsCount?: Maybe<Scalars['Int']['output']>;
  readsJson?: Maybe<Scalars['Object']['output']>;
  title: Scalars['String']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageEvent = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'MessageEvent';
  doctor?: Maybe<Doctor>;
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Message>;
  /** ISO-8601 */
  openedAt?: Maybe<Scalars['DateTime']['output']>;
  /** ISO-8601 */
  readAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MessageEventDtoInput = {
  msgId?: InputMaybe<Scalars['Int']['input']>;
  open: Scalars['Boolean']['input'];
  read: Scalars['Boolean']['input'];
};

export enum MessagesListType {
  All = 'ALL',
  Global = 'GLOBAL',
  Personal = 'PERSONAL'
}

/** Mutation root */
export type Mutation = {
  __typename?: 'Mutation';
  DeleteExam?: Maybe<Response>;
  DeleteReferralRequest?: Maybe<Response>;
  DoctorUpdate?: Maybe<Doctor>;
  GetExamPdf?: Maybe<FileDto>;
  PatientUpdate?: Maybe<PatientDto>;
  SaveReferralRequest?: Maybe<ReferralRequest>;
  SendMail?: Maybe<Response>;
  SetExamDoctorAction?: Maybe<Response>;
  SetReferralDoctorAction?: Maybe<Response>;
  Settings?: Maybe<Response>;
  UpdateMessageEvent?: Maybe<Response>;
};


/** Mutation root */
export type MutationDeleteExamArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationDeleteReferralRequestArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationDoctorUpdateArgs = {
  dto?: InputMaybe<DoctorDtoInput>;
};


/** Mutation root */
export type MutationGetExamPdfArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  registerView?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Mutation root */
export type MutationPatientUpdateArgs = {
  patient?: InputMaybe<PatientDtoInput>;
};


/** Mutation root */
export type MutationSaveReferralRequestArgs = {
  dto?: InputMaybe<ReferralRequestDtoInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSendMailArgs = {
  data?: InputMaybe<SendDataInput>;
};


/** Mutation root */
export type MutationSetExamDoctorActionArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSetReferralDoctorActionArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Mutation root */
export type MutationSettingsArgs = {
  dto?: InputMaybe<SettingsDtoInput>;
};


/** Mutation root */
export type MutationUpdateMessageEventArgs = {
  dto?: InputMaybe<MessageEventDtoInput>;
};

export type Order = {
  __typename?: 'Order';
  deleted: Scalars['Boolean']['output'];
  doctor: Doctor;
  id?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  issueDate: Scalars['Date']['output'];
  notes: Scalars['String']['output'];
  number?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  packageArrival: Scalars['Date']['output'];
  receivedMoney?: Maybe<Scalars['Float']['output']>;
  referrals?: Maybe<Array<Maybe<Referral>>>;
  tsv?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum PFlagType {
  Inherited = 'INHERITED',
  Manual = 'MANUAL',
  None = 'NONE'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  displayXtoYofZ?: Maybe<Scalars['String']['output']>;
  hasNext: Scalars['Boolean']['output'];
  hasPrev: Scalars['Boolean']['output'];
  pageIndex: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
  totalPageCount: Scalars['Int']['output'];
};

export type PagedList_DoctorInventoryTotal = {
  __typename?: 'PagedList_DoctorInventoryTotal';
  items?: Maybe<Array<Maybe<DoctorInventoryTotal>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PagedList_Exam = {
  __typename?: 'PagedList_Exam';
  items?: Maybe<Array<Maybe<Exam>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PagedList_Invoice = {
  __typename?: 'PagedList_Invoice';
  items?: Maybe<Array<Maybe<Invoice>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PagedList_PatientDto = {
  __typename?: 'PagedList_PatientDto';
  items?: Maybe<Array<Maybe<PatientDto>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PagedList_Receipt = {
  __typename?: 'PagedList_Receipt';
  items?: Maybe<Array<Maybe<Receipt>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PagedList_Referral = {
  __typename?: 'PagedList_Referral';
  items?: Maybe<Array<Maybe<Referral>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type PagedList_ReferralRequest = {
  __typename?: 'PagedList_ReferralRequest';
  items?: Maybe<Array<Maybe<ReferralRequest>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type Patient = {
  __typename?: 'Patient';
  /** ISO-8601 */
  birthDate?: Maybe<Scalars['Date']['output']>;
  cache?: Maybe<Scalars['Object']['output']>;
  clinic: Clinic;
  deleted: Scalars['Boolean']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullAddress?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  partner?: Maybe<Patient>;
  phone?: Maybe<Scalars['String']['output']>;
  referrals?: Maybe<Array<Maybe<Referral>>>;
  ssn: Scalars['String']['output'];
  tsv?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PatientDto = {
  __typename?: 'PatientDto';
  /** ISO-8601 */
  birthDate?: Maybe<Scalars['Date']['output']>;
  cache?: Maybe<Scalars['Object']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  ssn?: Maybe<Scalars['String']['output']>;
};

export type PatientDtoInput = {
  /** ISO-8601 */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  cache?: InputMaybe<Scalars['Object']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type Pattern = {
  __typename?: 'Pattern';
  content?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<PatternModel>;
  name: Scalars['String']['output'];
  type: PatternType;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum PatternModel {
  All = 'ALL',
  Exam = 'EXAM',
  ExamEmail = 'EXAM_EMAIL',
  Invoice = 'INVOICE',
  InvoiceEmail = 'INVOICE_EMAIL',
  Receipt = 'RECEIPT',
  ReceiptEmail = 'RECEIPT_EMAIL',
  System = 'SYSTEM'
}

export enum PatternType {
  Conclusion = 'CONCLUSION',
  Description = 'DESCRIPTION',
  DoctorData = 'DOCTOR_DATA',
  FiscalData = 'FISCAL_DATA',
  Footer = 'FOOTER',
  Header = 'HEADER',
  Images = 'IMAGES',
  InvoiceData = 'INVOICE_DATA',
  Main = 'MAIN',
  PatientData = 'PATIENT_DATA',
  Recommendation = 'RECOMMENDATION',
  Result = 'RESULT',
  Spacer = 'SPACER',
  Title = 'TITLE'
}

export enum PaymentMethod {
  Bank = 'BANK',
  Cash = 'CASH',
  Other = 'OTHER'
}

export type Placeholder = {
  __typename?: 'Placeholder';
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<Maybe<PlaceholderValue>>>;
};

export type PlaceholderValue = {
  __typename?: 'PlaceholderValue';
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  label: Scalars['String']['output'];
  placeholder: Placeholder;
  position: Scalars['Int']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

/** Query root */
export type Query = {
  __typename?: 'Query';
  ClinicList?: Maybe<Array<Maybe<Clinic>>>;
  Doctor?: Maybe<Doctor>;
  DoctorDashboard?: Maybe<DoctorDashboard>;
  Exam?: Maybe<Exam>;
  ExamGroupList?: Maybe<Array<Maybe<ExamGroup>>>;
  ExamPagedList?: Maybe<PagedList_Exam>;
  GeneratePdf?: Maybe<FileDto>;
  GetAllPdfs?: Maybe<FileDto>;
  ImageContent?: Maybe<ImageDto>;
  Invoice?: Maybe<Invoice>;
  InvoicePagedList?: Maybe<PagedList_Invoice>;
  MessagesList?: Maybe<Array<Maybe<Message>>>;
  MyInventoryList?: Maybe<PagedList_DoctorInventoryTotal>;
  MyPatients?: Maybe<PagedList_PatientDto>;
  Patient?: Maybe<PatientDto>;
  PatientIdBySsn?: Maybe<Patient>;
  PatientSsnSubList?: Maybe<Array<Maybe<Patient>>>;
  Pattern?: Maybe<Pattern>;
  PatternsList?: Maybe<Array<Maybe<Pattern>>>;
  Placeholder?: Maybe<Placeholder>;
  Receipt?: Maybe<Receipt>;
  ReceiptsByReferral?: Maybe<Array<Maybe<Receipt>>>;
  ReceiptsPagedList?: Maybe<PagedList_Receipt>;
  Referral?: Maybe<Referral>;
  ReferralPagedList?: Maybe<PagedList_Referral>;
  ReferralRequest?: Maybe<ReferralRequest>;
  ReferralRequestPagedList?: Maybe<PagedList_ReferralRequest>;
  Settings?: Maybe<Settings>;
};


/** Query root */
export type QueryClinicListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryExamArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryExamGroupListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryExamPagedListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryGeneratePdfArgs = {
  content?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryGetAllPdfsArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryImageContentArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryInvoiceArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryInvoicePagedListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryMessagesListArgs = {
  type?: InputMaybe<MessagesListType>;
};


/** Query root */
export type QueryMyInventoryListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryMyPatientsArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryPatientArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryPatientIdBySsnArgs = {
  ssn?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryPatientSsnSubListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryPatternArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryPatternsListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryPlaceholderArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


/** Query root */
export type QueryReceiptArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryReceiptsByReferralArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryReceiptsPagedListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryReferralArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryReferralPagedListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QueryReferralRequestArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


/** Query root */
export type QueryReferralRequestPagedListArgs = {
  params?: InputMaybe<BaseParamsInput>;
};


/** Query root */
export type QuerySettingsArgs = {
  context?: InputMaybe<Scalars['String']['input']>;
};

export type Receipt = AadeSource_Int & EntityInterface_Int & IdContainer_Int & {
  __typename?: 'Receipt';
  aadeResponse?: Maybe<Scalars['Object']['output']>;
  aadeStatus?: Maybe<AadeSyncStatus>;
  clinic?: Maybe<Clinic>;
  /** ISO-8601 */
  createdAt?: Maybe<Scalars['Date']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['Object']['output']>;
  deleted: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  num?: Maybe<Scalars['String']['output']>;
  patient?: Maybe<Patient>;
  referral?: Maybe<Referral>;
  status?: Maybe<ReceiptStatus>;
  template: ReceiptTemplate;
  total?: Maybe<Scalars['Float']['output']>;
  typical: Scalars['Boolean']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type ReceiptGroup = {
  __typename?: 'ReceiptGroup';
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  multiIssue: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Scalars['Object']['output']>;
  templates?: Maybe<Array<Maybe<ReceiptTemplate>>>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum ReceiptStatus {
  Annulled = 'ANNULLED',
  Closed = 'CLOSED',
  Opened = 'OPENED'
}

export type ReceiptTemplate = {
  __typename?: 'ReceiptTemplate';
  active?: Maybe<Scalars['Boolean']['output']>;
  clinic?: Maybe<Clinic>;
  data?: Maybe<Scalars['Object']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  examsGroup?: Maybe<ExamGroup>;
  groups?: Maybe<Array<Maybe<ReceiptGroup>>>;
  id?: Maybe<Scalars['Int']['output']>;
  imagesGroup?: Maybe<ImageGroup>;
  name?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Pattern>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum RecipientType {
  Doctor = 'DOCTOR',
  Other = 'OTHER',
  Patient = 'PATIENT'
}

export type Referral = {
  __typename?: 'Referral';
  clinic: Clinic;
  clinicSettings?: Maybe<ExamGroupClinicSettings>;
  data?: Maybe<Scalars['Object']['output']>;
  /** ISO-8601 */
  date: Scalars['Date']['output'];
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  doctor: Doctor;
  emergency: Scalars['Boolean']['output'];
  exams?: Maybe<Array<Maybe<Exam>>>;
  group: ExamGroup;
  grouping?: Maybe<ReferralGroup>;
  id?: Maybe<Scalars['Int']['output']>;
  insurance: Insurance;
  invoiceBundle?: Maybe<InvoiceBundle>;
  invoiceRow?: Maybe<InvoiceRow>;
  labId?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  lastMenstruation?: Maybe<Scalars['Date']['output']>;
  mainGroupName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  notesViewed: Scalars['Boolean']['output'];
  /** ISO-8601 */
  notesVisibleAfter?: Maybe<Scalars['Date']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Order>;
  pFlag?: Maybe<PFlagType>;
  patient: Patient;
  protocolId?: Maybe<Scalars['String']['output']>;
  receipts?: Maybe<Array<Maybe<Receipt>>>;
  relatives?: Maybe<Array<Maybe<Referral>>>;
  /** ISO-8601 */
  sampleDate: Scalars['Date']['output'];
  sourcedReceipt?: Maybe<Array<Maybe<Receipt>>>;
  templateName?: Maybe<Scalars['String']['output']>;
  tsv?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export type ReferralGroup = EntityInterface_String & IdContainer_String & {
  __typename?: 'ReferralGroup';
  id?: Maybe<Scalars['String']['output']>;
  /** ISO-8601 */
  maxDate?: Maybe<Scalars['Date']['output']>;
  referrals?: Maybe<Array<Maybe<Referral>>>;
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ReferralRequest = EntityInterface_Int & IdContainer_Int & {
  __typename?: 'ReferralRequest';
  /** ISO-8601 */
  birthDate?: Maybe<Scalars['Date']['output']>;
  deleted: Scalars['Boolean']['output'];
  doctor: Doctor;
  examGroup: ExamGroup;
  firstName: Scalars['String']['output'];
  id?: Maybe<Scalars['Int']['output']>;
  /** ISO-8601 */
  lastMenstruation?: Maybe<Scalars['Date']['output']>;
  lastName: Scalars['String']['output'];
  patient?: Maybe<Patient>;
  ssn: Scalars['String']['output'];
};

export type ReferralRequestDtoInput = {
  /** ISO-8601 */
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  doctorId?: InputMaybe<Scalars['Int']['input']>;
  examGroupId?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** ISO-8601 */
  lastMenstruation?: InputMaybe<Scalars['Date']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patientId?: InputMaybe<Scalars['Int']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type ReportInventoryByDoctor = EntityInterface_String & IdContainer_String & {
  __typename?: 'ReportInventoryByDoctor';
  doctor?: Maybe<Doctor>;
  id?: Maybe<Scalars['String']['output']>;
  inventory?: Maybe<Inventory>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type Response = {
  __typename?: 'Response';
  message?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export enum ResultDeliveryMethod {
  Biorec = 'BIOREC',
  Email = 'EMAIL',
  Other = 'OTHER',
  Printed = 'PRINTED'
}

export type SendDataInput = {
  emailContent?: InputMaybe<Scalars['String']['input']>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  pdfContent?: InputMaybe<Scalars['String']['input']>;
  recipient?: InputMaybe<Scalars['String']['input']>;
};

export type Settings = EntityInterface_SettingsPk & IdContainer_SettingsPk & {
  __typename?: 'Settings';
  content?: Maybe<Scalars['Object']['output']>;
  id?: Maybe<SettingsPk>;
};

export type SettingsDtoInput = {
  content?: InputMaybe<Scalars['Object']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
};

export type SettingsPk = {
  __typename?: 'SettingsPK';
  context?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
};

export type SortMetadataInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
};

export type Tag = {
  __typename?: 'Tag';
  color?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  model: TagModel;
  name: Scalars['String']['output'];
  /** ISO-8601 */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export enum TagModel {
  Doctor = 'DOCTOR',
  ExamGroup = 'EXAM_GROUP',
  ExamTemplate = 'EXAM_TEMPLATE'
}
